import React from 'react'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import TileSelectList from 'components/TileSelectList'

import AussieRules from 'icons/AussieRules'
import Baseball from 'icons/Baseball'
import Basketball from 'icons/Basketball'
import Boxing from 'icons/Boxing'
import Cricket from 'icons/Cricket'
import Darts from 'icons/Darts'
import Football from 'icons/Football'
import Golf from 'icons/Golf'
import HorseRacing from 'icons/HorseRacing'
import IceHockey from 'icons/IceHockey'
import MMA from 'icons/MMA'
import Motorsports from 'icons/Motorsports'
import Rugby from 'icons/Rugby'
import Soccer from 'icons/Soccer'
import Tennis from 'icons/Tennis'

import FormsStore from 'stores/forms'
import { useStore } from 'hooks'

const FavoriteSportsSchema = Yup.object().shape({
  favorite_sports: Yup.array()
    .of(Yup.string().trim().min(1, 'This field is required').required('This field is required'))
    .min(1, 'Please choose an item')
    .required('Please choose an item')
})

const favoriteSportsOptions = [
  {
    value: 'soccer',
    label: 'Soccer',
    icon: Soccer
  },
  {
    value: 'football',
    label: 'Football',
    icon: Football
  },
  {
    value: 'baseball',
    label: 'Baseball',
    icon: Baseball
  },
  {
    value: 'tennis',
    label: 'Tennis',
    icon: Tennis
  },
  {
    value: 'basketball',
    label: 'Basketball',
    icon: Basketball
  },
  {
    value: 'golf',
    label: 'Golf',
    icon: Golf
  },
  {
    value: 'motorsports',
    label: 'Motorsports',
    icon: Motorsports
  },
  {
    value: 'horse racing',
    label: 'Horse Racing',
    icon: HorseRacing
  },
  {
    value: 'darts',
    label: 'Darts',
    icon: Darts
  },
  {
    value: 'mma',
    label: 'MMA',
    icon: MMA
  },
  {
    value: 'aussie rules',
    label: 'Aussie Rules',
    icon: AussieRules
  },
  {
    value: 'cricket',
    label: 'Cricket',
    icon: Cricket
  },
  {
    value: 'ice hockey',
    label: 'Ice Hockey',
    icon: IceHockey
  },
  {
    value: 'rugby',
    label: 'Rugby',
    icon: Rugby
  },
  {
    value: 'boxing',
    label: 'Boxing',
    icon: Boxing
  }
]

const FavoriteSportsForm = () => {
  const router = useRouter()
  const formsStore = useStore(FormsStore)
  const handleSubmit = ({ favorite_sports }) => {
    // add info to the forms store
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'What are your favorite sports?',
      answer: favorite_sports
    })

    router.push('/barstool-sportsbook/favorite-teams')
  }
  return (
    <Formik
      initialValues={{
        favorite_sports: []
      }}
      validationSchema={FavoriteSportsSchema}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form className='sportsBookForm'>
          <Field name='favorite_sports'>
            {({ field, form }) => (
              <TileSelectList
                {...field}
                {...form}
                onChange={(sports) => setFieldValue(field.name, sports)}
                options={favoriteSportsOptions}
                allowOtherOption
              />
            )}
          </Field>
          <ErrorMessage name='favorite_sports' component='div' className='field__error' />
          <br />
          <button
            type='submit'
            className={`sportsBook__submitButton${!values?.favorite_sports?.length ? '--disabled' : ''}`}
            disabled={!values?.favorite_sports?.length}
          >
            Continue
          </button>
        </Form>
      )}
    </Formik>
  )
}

export default FavoriteSportsForm
